import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../hooks/useAuth';
import FormBuilder from '../components/FormBuilder';

const EditForm = () => {
  const { formId } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchForm();
  }, [formId]);

  const fetchForm = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/forms/${formId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setForm(response.data);
    } catch (err) {
      setError('Failed to fetch form');
      console.error('Error fetching form:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (formData) => {
    try {
      setSaving(true);
      await axios.put(`/api/forms/${formId}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      navigate('/forms');
    } catch (err) {
      alert('Failed to update form. Please try again.');
      console.error('Error updating form:', err);
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    navigate('/forms');
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (error || !form) {
    return (
      <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-md">
        {error || 'Form not found'}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Edit Form</h1>
        <p className="text-gray-600 mt-1">Update your custom form</p>
      </div>

      {saving && (
        <div className="bg-blue-50 border border-blue-200 text-blue-700 px-4 py-3 rounded-md">
          Saving changes...
        </div>
      )}

      <FormBuilder initialForm={form} onSave={handleSave} onCancel={handleCancel} />
    </div>
  );
};

export default EditForm;
